import { Link } from 'react-router-dom'
import './PriceList.css'

const PriceList = () => {
  return (
    <div className="price-list-page">
      <div className="page-header">
        <div>
          <h2>AI Security Pricing</h2>
          <p className="subtitle">Complete pricing breakdown for all products and plans</p>
        </div>
      </div>

      <div className="price-list-container">
        {/* Individual Certification Exams */}
        <section className="price-section">
          <h3>Individual Certification Exams</h3>
          <div className="table-container">
            <table className="price-table">
              <thead>
                <tr>
                  <th>Certification</th>
                  <th>Price</th>
                  <th>Target</th>
                  <th>Access Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>AIsec AI Security Fundamentals Certification Exam</td>
                  <td>$199</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
                <tr>
                  <td>AIsec Secure Developer Certification Exam</td>
                  <td>$249</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
                <tr>
                  <td>AIsec Security Leader Certification Exam</td>
                  <td>$249</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
                <tr>
                  <td>AIsec Governance & Risk Certification Exam</td>
                  <td>$249</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
                <tr>
                  <td>AIsec Penetration Tester Certification Exam</td>
                  <td>$299</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
                <tr>
                  <td>AIsec Security Engineer Certification Exam</td>
                  <td>$249</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
                <tr>
                  <td>AIsec Security Architect Certification Exam</td>
                  <td>$299</td>
                  <td>Individual</td>
                  <td>Valid 3 years</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Individual Course Access */}
        <section className="price-section">
          <h3>Individual Course Access</h3>
          <div className="table-container">
            <table className="price-table">
              <thead>
                <tr>
                  <th>Course</th>
                  <th>Price</th>
                  <th>Target</th>
                  <th>Access Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>AI Security Architect</td>
                  <td>$99</td>
                  <td>Individual</td>
                  <td>One time, 3 month access</td>
                </tr>
                <tr>
                  <td>AI Security GRC</td>
                  <td>$99</td>
                  <td>Individual</td>
                  <td>One time, 3 month access</td>
                </tr>
                <tr>
                  <td>AI Security Engineer</td>
                  <td>$99</td>
                  <td>Individual</td>
                  <td>One time, 3 month access</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Individual Subscriptions */}
        <section className="price-section">
          <h3>Individual Subscriptions</h3>
          <div className="table-container">
            <table className="price-table">
              <thead>
                <tr>
                  <th>Subscription</th>
                  <th>Price</th>
                  <th>Target</th>
                  <th>Access Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Annual Subscription (all courses)</td>
                  <td>$299</td>
                  <td>Individual</td>
                  <td>Annual access</td>
                </tr>
                <tr>
                  <td>Monthly Subscription (all courses)</td>
                  <td>$39</td>
                  <td>Individual</td>
                  <td>Monthly access</td>
                </tr>
                <tr>
                  <td>Premium Subscription (all courses, 1 cert)</td>
                  <td>$399</td>
                  <td>Individual</td>
                  <td>Annual access</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Enterprise Plans */}
        <section className="price-section">
          <div className="section-header-with-link">
            <h3>Enterprise Plans</h3>
            <p className="playbook-reference">
              For detailed enterprise pricing policies, negotiation guidelines, and sales playbook, see the{' '}
              <Link to="/pricing-playbook" className="playbook-link">Pricing Playbook</Link>.
            </p>
          </div>
          <div className="table-container">
            <table className="price-table enterprise-table">
              <thead>
                <tr>
                  <th>Plan</th>
                  <th>Price/Users</th>
                  <th>Target Audience</th>
                  <th>Includes</th>
                  <th>Effective Price</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Enterprise Core</strong></td>
                  <td>$1,999<br />(10-20 users)</td>
                  <td>Small-mid enterprises, security-aware teams</td>
                  <td>
                    <ul>
                      <li>All AI Security Courses</li>
                      <li>All Labs</li>
                      <li>Centralized admin dashboard</li>
                      <li>Basic reporting (completion, participation)</li>
                      <li>Email support</li>
                      <li>AIsec branding</li>
                    </ul>
                    <p className="note">Entry Enterprise SKU</p>
                  </td>
                  <td>~$100/user/year</td>
                  <td>Annual</td>
                </tr>
                <tr>
                  <td><strong>Enterprise Professional</strong></td>
                  <td>$4,999<br />(21-50 users)</td>
                  <td>Regulated industries, AI-heavy organizations</td>
                  <td>
                    <ul>
                      <li>Everything in Enterprise Core</li>
                      <li>PLUS 1 Certification exam per user (choice of cert)</li>
                      <li>Priority support</li>
                      <li>Quarterly usage review (light-touch)</li>
                    </ul>
                    <p className="note">Very compelling value</p>
                  </td>
                  <td>~$100/user/year including certs</td>
                  <td>Annual</td>
                </tr>
                <tr>
                  <td><strong>Enterprise Advanced</strong></td>
                  <td>Starting from $9,999<br />(Minimum 50 users)</td>
                  <td>Financial services, healthcare, government, AI product companies</td>
                  <td>
                    <ul>
                      <li>Everything in Enterprise Professional</li>
                      <li>PLUS Multiple certifications per user (e.g., 2)</li>
                      <li>Named account manager</li>
                    </ul>
                  </td>
                  <td>Custom pricing</td>
                  <td>Annual</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Enterprise Add-ons */}
        <section className="price-section">
          <h3>Enterprise Add-ons & Expansions</h3>
          <div className="table-container">
            <table className="price-table">
              <thead>
                <tr>
                  <th>Add-on</th>
                  <th>Price</th>
                  <th>Details</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Enterprise Certifications</strong></td>
                  <td>$149</td>
                  <td>Extra certifications at a $149 per exam enterprise-only rate</td>
                  <td>Annual</td>
                </tr>
                <tr>
                  <td><strong>Enterprise Seat Expansion</strong><br />Option 1</td>
                  <td>$89/user/year</td>
                  <td>Courses + Labs (enterprise-only rate)</td>
                  <td>Annual</td>
                </tr>
                <tr>
                  <td><strong>Enterprise Seat Expansion</strong><br />Option 2</td>
                  <td>$149/user/year</td>
                  <td>With Certification (enterprise-only rate)</td>
                  <td>Annual</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  )
}

export default PriceList

